import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Snackbar,
  Stack,
  CircularProgress,
} from "@mui/material";
import CompanyView from "./CompanyViewIndex";
import InitiativesView from "./InitiativesViewIndex";
import StrategicRoadmapView from "./StrategicRoadmapViewIndex";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import RiskMatrixView from "./RiskMatrixIndex";
import MDBox from "components/MDBox";
import { getCompanies } from "services/api";
import { useAuth } from "context/authContext";
import CompanyModel from "models/companyModel";
import LoadingScreen from "components/Loading";
import { useTranslation } from "react-i18next";
import MDButton from "components/MDButton";
import { CloudDownload } from "@mui/icons-material";
import { exportHighLevelTemplate } from "services/api";
import { hasEditAccess } from "services/utils";
import { buttonStyles } from "services/utils";

const StrategicInfo = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(0); // 0 = Company, 1 = Initiatives
  const [selectedCompany, setSelectedCompany] = useState(null);
  const { companies, setCompanies, employees, modules, employee } = useAuth();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!companies) {
        let comps = await getCompanies();

        if (comps !== "error") {
          const companyList = comps.map((c) => new CompanyModel(c));
          setCompanies(companyList);
          if (companyList.length > 0) {
            setSelectedCompany(companyList[0]);
          }
        }
      } else {
        setSelectedCompany(companies[0]);
      }
    };
    setCanEdit(hasEditAccess(modules, "Strategic Info", employee));
    fetchData().then((e) => {
      setLoading(false);
    });
  }, []);

  const handleExport = async () => {
    setDownloadLoading(true);
    //do something
    await exportHighLevelTemplate();
    setDownloadLoading(false);
  };

  return (
    <>
      <MDBox pb={2}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: "stretch", sm: "center" }}
        >
          {/* Left section: View toggle buttons */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems="center"
            flexWrap="wrap"
          >
            <Button
              sx={buttonStyles(view === 0)}
              variant={view === 0 ? "contained" : "outlined"}
              onClick={() => setView(0)}
            >
              {t("admin.strategicInfo.company")}
            </Button>
            {employee?.role === 1 && (
              <Button
                sx={buttonStyles(view === 1)}
                variant={view === 1 ? "contained" : "outlined"}
                onClick={() => setView(1)}
              >
                {t("admin.strategicInfo.strategicRoadmap.title")}
              </Button>
            )}

            <Button
              sx={{ ...buttonStyles(view === 2) }}
              variant={view === 2 ? "contained" : "outlined"}
              onClick={() => setView(2)}
            >
              {t("admin.strategicInfo.initiativeName")}
            </Button>
            <Button
              sx={buttonStyles(view === 3)}
              variant={view === 3 ? "contained" : "outlined"}
              onClick={() => setView(3)}
            >
              {t("admin.strategicInfo.riskManagement.title")}
            </Button>
          </Stack>

          {/* Right section: Export button */}
          <Box
            mt={{ xs: 2, sm: 0 }}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-end" }}
          >
            <MDButton
              color="primary"
              onClick={handleExport}
              startIcon={<CloudDownload />}
              disabled={downloadLoading}
              size="small"
              sx={{
                minWidth: { xs: "100%", sm: "auto" },
                px: { xs: 2, sm: 3 },
              }}
            >
              {downloadLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                t("admin.strategicInfo.highLevel")
              )}
            </MDButton>
          </Box>
        </Stack>
      </MDBox>

      {loading ? (
        <LoadingScreen />
      ) : view === 0 ? (
        <CompanyView
          company={selectedCompany}
          setSelectedCompany={setSelectedCompany}
          canEdit={canEdit}
        />
      ) : view === 1 ? (
        <StrategicRoadmapView canEdit={canEdit} />
      ) : view === 2 ? (
        <InitiativesView canEdit={canEdit} />
      ) : view === 3 ? (
        <RiskMatrixView canEdit={canEdit} />
      ) : null}
    </>
  );
};

export default StrategicInfo;
